// extracted by mini-css-extract-plugin
export default {"card":"PlanPrice_card__OQH5W","header":"PlanPrice_header__P7A4y","desc":"PlanPrice_desc__tqW3H"};